import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({email: Yup.string().required("Email is Required"), password: Yup.string().required("Password is Required")});

export const RequestValidationSchema = Yup.object().shape({
       requesttype: Yup.string().required("Request Type is required"),
        allowedsite: Yup.array().when('requesttype', {
          is: (requesttype: string) => requesttype !== 'deactivation',
          then: Yup.array().min(1, "Requested Site is required").required("required"),
          otherwise: Yup.array()
        }),
    alloweddoor: Yup.array().when('requesttype', {
      is: (requesttype: string) => requesttype !== 'deactivation',
      then: Yup.array().min(1, "Requested Door is required").required("required"),
      otherwise: Yup.array()
    }),
    startdate: Yup.date().when('requesttype', {
      is: (requesttype: string) => requesttype !== 'deactivation',
      then: Yup.date().required("StartDate is required").nullable(),
      otherwise: Yup.date().nullable()
    }),
    requestDuration: Yup.string().when('requesttype', {
      is: (requesttype: string) => requesttype !== 'deactivation',
      then: Yup.string().required("Request Duration is required").nullable(),
      otherwise: Yup.string().nullable()
    }),
    // rejectionReason:Yup.string().required("Rejection reason Type is required")
});


export const SiteValidationSchema = Yup.object().shape({
    sitename: Yup.string().required("Site name is required"), 
    region: Yup.string().required("Region is required")});

export const DoorLocationValidationSchema = Yup.object().shape({
    siteId: Yup.string().required("Site is required"),
    alloweddoor: Yup.string().required("Door is required")});

export const ApproverValidationSchema = Yup.object().shape({
        oracleId: Yup.string().required("Approver is required"), 
        locations: Yup.array().min(1, "Location is required").required("required"),
        approverRole: Yup.string().required("Approver Role is required")});

export const DelegationValidationSchema = Yup.object().shape({
    oracleId: Yup.string().required("Delegated To is required"),
    date: Yup.string().required("Date is required")
   });
   export const DelegationAdminValidationSchema = Yup.object().shape({
    delegatedBy: Yup.string().required("Delegated By is required"),
    delegatedTo: Yup.string().required("Delegated To is required"),
    date: Yup.string().required("Date is required")
   });



